<template>
    <div
        class="ds-spinner"
        :class="`ds-spinner-${variant}`"
        data-testid="ds-spinner"
        role="status"
    >
        <slot name="before" />
        <span class="sr-only">{{ screenReaderText }}</span>
        <div class="relative inline-flex items-center justify-center">
            <DsIcon
                icon="fa-duotone fa-solid fa-spinner-third"
                :size
                spin
            />
            <DsIcon
                v-if="centerIcon"
                class="absolute"
                :icon="centerIcon"
                :size="centerIconSize || size"
            />
        </div>
        <slot name="after" />
    </div>
</template>

<script setup lang="ts">
import DsIcon, { type DsIconProps } from '@ds/DsIcon.vue';

export type DsSpinnerProps = {
    size?: DsIconProps['size'];
    variant?: 'primary' | 'secondary' | 'destructive' | 'inverse' | 'unset' | 'brand';
    screenReaderText?: string;
    centerIcon?: DsIconProps['icon'];
    centerIconSize?: DsIconProps['size'];
};

withDefaults(defineProps<DsSpinnerProps>(), {
    size: 'md',
    variant: 'unset',
    screenReaderText: 'Loading...',
});
</script>

<style scoped lang="scss">
.ds-spinner {
    --fa-animation-duration: 1s;

    &-primary .ds-icon-frame {
        @apply text-ds-gray-800;
    }
    &-secondary .ds-icon-frame {
        @apply text-ds-gray-800;
    }
    &-destructive .ds-icon-frame {
        @apply text-ds-red-700;
    }
    &-inverse .ds-icon-frame {
        @apply text-white;
    }
    &-brand .ds-icon-frame {
        @apply text-ds-orange-400;
    }
}
</style>
